export const moduloUm = [
    {
        "id": "1",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte I_v2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Parte II_1.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Treinamento.pdf",
        "path": "./treinamento/Treinamento.pdf",
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "path": "./treinamento/Estruturacao de Fundos_Aplicacao em Aula.pdf",
        "type": "pdf"
    },
    {
        "id": "5",
        "arquivo": "FIDC-Lamina-v.diagramada.pdf",
        "path": "./treinamento/FIDC-Lamina-v.diagramada.pdf",
        "type": "pdf"
    },
    {
        "id": "6",
        "arquivo": "LAMINA MULTIMERCADO.pdf",
        "path": "./treinamento/LAMINA MULTIMERCADO.pdf",
        "type": "pdf"
    },
    {
        "id": "7",
        "arquivo": "Regulamento FIDC.pdf",
        "path": "./treinamento/Regulamento FIDC.pdf",
        "type": "pdf"
    },
    {
        "id": "8",
        "arquivo": "Regulamento Multimercado.pdf",
        "path": "./treinamento/Regulamento Multimercado.pdf",
        "type": "pdf"
    },
    {
        "id": "9",
        "arquivo": "Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Derivativos.pdf",
        "type": "pdf"
    },
    {
        "id": "10",
        "arquivo": "Derivativos.xlsx",
        "path": "./treinamento/Derivativos.xlsx",
        "type": "xlsx"
    },
    {
        "id": "11",
        "arquivo": "cotas securitizacao.xlsx",
        "path": "./treinamento/cotas securitizacao.xlsx",
        "type": "xlsx"
    },
    {
        "id": "12",
        "arquivo": "Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "path": "./treinamento/Mercado Pago_Mercado Financeiro_Resumo.pdf",
        "type": "pdf"
    },
]

export const moduloDois = [
    {
        "id": "1",
        "arquivo": "C2P_Módulo2.pdf",
        "path": "./treinamento/C2P_Modulo2.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "demonstracao_financeira_MPB_062025_FINAL.pdf",
        "path": "./treinamento/demonstracao_financeira_MPB_062025_FINAL.pdf",
        "type": "pdf"
    },
    {
        "id": "3",
        "arquivo": "Exemplo.xlsx",
        "path": "./treinamento/Exemplo.xlsx",
        "type": "pdf"
    },
    {
        "id": "4",
        "arquivo": "JPM_DemonstracoesConsolidadas_IFRS.pdf",
        "path": "./treinamento/JPM_DemonstracoesConsolidadas_IFRS.pdf",
        "type": "pdf"
    },
]

export const moduloTres = [
    {
        "id": "1",
        "arquivo": "Gestão de Risco.pdf",
        "path": "./treinamento/Gestao de Risco.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Derivativos_Sadia.xlsx",
        "path": "./treinamento/Derivativos_Sadia.xlsx",
        "type": "xlsx"
    },
]

export const moduloQuatro = [
    {
        "id": "1",
        "arquivo": "Módulo RM - parte 1.pdf",
        "path": "./treinamento/Modulo RM - parte 1.pdf",
        "type": "pdf"
    },
    {
        "id": "2",
        "arquivo": "Dados para exercícios - parte 01.xlsx",
        "path": "./treinamento/Dados para exercicios - parte 01.xlsx",
        "type": "xlsx"
    },
    {
        "id": "3",
        "arquivo": "LC de RM - 01.pdf",
        "path": "./treinamento/LC de RM - 01.pdf",
        "type": "xlsx"
    },
    {
        "id": "4",
        "arquivo": "Quiz 01 - Risco de Mercado - Conceitos Introdutórios",
        "path": "https://forms.office.com/r/5u3r0z9TUt",
        "type": "link"
    },
    {
        "id": "5",
        "arquivo": "LC de RM - 02.pdf",
        "path": "./treinamento/LC de RM - 02.pdf",
        "type": "xlsx"
    },
    {
        "id": "6",
        "arquivo": "Quiz 02 - Conceitos Matemáticos e Estatísticos",
        "path": "https://forms.office.com/r/ihq5FnmpvY",
        "type": "link"
    },
    {
        "id": "7",
        "arquivo": "Módulo RM - parte 2.pdf",
        "path": "./treinamento/Modulo RM - parte 2.pdf",
        "type": "arquivo"
    },
    {
        "id": "8",
        "arquivo": "LC de RM - 03.pdf",
        "path": "./treinamento/LC de RM - 03.pdf",
        "type": "arquivo"
    },
    {
        "id": "9",
        "arquivo": "Quiz 03 - Estimativa Volatilidade",
        "path": "https://forms.office.com/r/kjTzNyvVwY",
        "type": "link"
    },
    {
        "id": "10",
        "arquivo": "LC de RM - 04.pdf",
        "path": "./treinamento/LC de RM - 04.pdf",
        "type": "arquivo"
    },
    {
        "id": "11",
        "arquivo": "Quiz 04 - Introdução Opções",
        "path": "https://forms.office.com/r/VaAzJGQnPg",
        "type": "link"
    },
    {
        "id": "12",
        "arquivo": "LC de RM - 05",
        "path": "./treinamento/LC de RM - 05.pdf",
        "type": "arquivo"
    },
    {
        "id": "13",
        "arquivo": "Quiz 05 - BS e RF",
        "path": "https://forms.office.com/r/vF0aC3kTHQ",
        "type": "link"
    },
    {
        "id": "14",
        "arquivo": "Módulo RM - parte 3",
        "path": "./treinamento/Modulo RM - parte 3.pdf",
        "type": "arquivo"
    },
    {
        "id": "15",
        "arquivo": "LC de RM - 06",
        "path": "./treinamento/LC de RM - 06.pdf",
        "type": "arquivo"
    },
    {
        "id": "16",
        "arquivo": "Quiz 06 - HEDGE",
        "path": "https://forms.office.com/r/s3wg7LgJYq",
        "type": "link"
    },
    {
        "id": "17",
        "arquivo": "LC de RM - 07",
        "path": "./treinamento/LC de RM - 07.pdf",
        "type": "arquivo"
    },
    {
        "id": "18",
        "arquivo": "Quiz 07 - VaR",
        "path": "https://forms.office.com/r/qBTSxtC1Ev",
        "type": "link"
    },
]